import styled from 'styled-components';

export const Container = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #6b7280;
`;

export const Icon = styled.i`
  font-size: 48px;
  color: #d1d5db;
  margin-bottom: 12px;
  display: block;
`;

export const Message = styled.p`
  font-size: 14px;
  margin: 0;
`;
